import Link from 'next/link';
import { FC, memo } from 'react';

import BaseLogo from './BaseLogo';

const Logo: FC = () => {
  return (
    <Link
      href={`${process.env.NEXT_PUBLIC_LEGACY_HOST}/${process.env.NEXT_PUBLIC_COUNTRY}/`}
    >
      <BaseLogo />
    </Link>
  );
};

export default memo(Logo);
